import React from "react";
import { Company } from "./types";

interface CompanyLogoProps {
    company: Company | null;
    logoUrl?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({ company, logoUrl }) => {
    return (
        <div className="profile-user position-relative d-inline-block mx-auto mb-2">
            {logoUrl ? (
                <img 
                    src={logoUrl} 
                    className="rounded-circle avatar-xl img-thumbnail user-profile-image shadow" 
                    alt="user-profile" 
                    style={{ marginTop: '-60px' }} 
                />
            ) : (
                <div className="avatar-xl img-thumbnail rounded-circle shadow bg-light d-flex align-items-center justify-content-center" style={{ marginTop: '-60px' }}>
                    <span className="display-4 text-primary fw-bold">
                        {company?.businessName?.charAt(0) || "+"}
                    </span>
                </div>
            )}
        </div>
    );
};

export default CompanyLogo;
